(function ($) {
    $('#btn-open-review').on('click touchstart', function (){
        $('.feedback__form').slideDown(300);
    });
})(jQuery);
